import { Component, Input, Output, EventEmitter } from '@angular/core';
import { ControlValueAccessor } from '@angular/forms';
import { NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'app-day-toggler',
  styleUrls: ['day-toggler.component.scss'],
  template: `
    <label class="day-toggler" [class.selected]="value">
      <input class="day-toggler__checkbox" type="checkbox" [(ngModel)]="value" />
      <span class="day-toggler__weekday">{{date | shortDate}}</span>
      <span class="day-toggler__day">{{date | date:'d'}}</span>
      <svg class="day-toggler__ico ico">
          <use xlink:href="assets/symbol/svg/sprite.css.svg#icon_check"></use>
      </svg>
    </label>
  `,
  providers: [
    {provide: NG_VALUE_ACCESSOR, useExisting: DayTogglerComponent, multi: true}
  ]
})
export class DayTogglerComponent implements ControlValueAccessor {
  @Input() date: Date;

  onTouch: Function;
  onModelChange: Function;

  innerValue: boolean;

  constructor() {}

  get value(): boolean {
    return this.innerValue;
  }
  set value(v: boolean) {
      this.innerValue = v;
      this.onModelChange(v);
  }

  writeValue(v: any): void {
      if (v === undefined) { return; }
      this.innerValue = v;
  }
  registerOnChange(fn: any): void {
      this.onModelChange = fn;
  }
  registerOnTouched(fn: any): void {
      this.onTouch = fn;
  }
  setDisabledState(isDisabled: boolean): void {}
}
